import * as _ from 'lodash';
import moment from 'moment';
import 'moment-timezone';
import { v4 as uuid } from 'uuid';
import { SurveyDatabaseRecord } from './survey-database-record';

export class SurveyResponseDocument extends SurveyDatabaseRecord {
  static objectStoreName = 'surveyResponseDocument';

  id: string;
  type: string;
  user_uuid: string;
  survey_template_id: string;
  survey_response: SurveyResponse[] = [];
  total_score: number;
  timestamp: moment.Moment;

  constructor (data: {} = {}) {
    super(data);
    this.id = data['id'] || uuid();
    this.type = data['type'];
    this.user_uuid = data['user_uuid'];
    this.survey_template_id = data['survey_template_id'];
    if (_.has(data, 'survey_response')) {
        this.survey_response = data['survey_response'];
    }
    this.total_score = data['total_score'];
    this.timestamp = moment(data['timestamp']);
  }

  toJSON() {
    return super.toJSON([
      'id',
      'type',
      'user_uuid',
      'survey_template_id',
      'survey_response',
      'total-score',
      'timestamp'
    ]);
  }
}

export class SurveyResponse extends SurveyDatabaseRecord {
    static objectStoreName = 'surveyResponse';

    category_id: string;
    category_name: string;
    answers: SurveyAnswer[] = [];
    category_score: number;

    constructor (data: {} = {}) {
      super(data);
      this.category_id = data['category_id'];
      this.category_name = data['category_name'];
      if (_.has(data, 'answers')) {
          this.answers = data['answers'];
      }
      this.category_score = data['category_score'];
    }

    toJSON() {
      return super.toJSON([
        'category_id',
        'category_name',
        'answers',
        'category_score'
      ]);
    }
}

export class SurveyAnswer extends SurveyDatabaseRecord {
    static objectStoreName = 'surveyAnswer';

    question_id: string;
    choice_id: string;
    choice_score: number;

    constructor (data: {} = {}) {
      super(data);
      this.question_id = data['question_id'];
      this.choice_id = data['choice_id'];
      this.choice_score = data['choice_score'];
    }

    toJSON() {
      return super.toJSON([
        'question_id',
        'choice_id',
        'choice_score'
      ]);
    }
}
